import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=85db4c30&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"
import style0 from "./Business.vue?vue&type=style&index=0&id=85db4c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85db4c30",
  null
  
)

export default component.exports